import { render, staticRenderFns } from "./StaffUpdate.vue?vue&type=template&id=7678dedf&scoped=true&"
import script from "./StaffUpdate.vue?vue&type=script&lang=js&"
export * from "./StaffUpdate.vue?vue&type=script&lang=js&"
import style0 from "./StaffUpdate.vue?vue&type=style&index=0&id=7678dedf&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7678dedf",
  null
  
)

export default component.exports